import { DatesForm } from './DateFormPage';
import { FacilityFormPage } from './FacilityFormPage';
import { SpecialtyBoardForm } from './SpecialtyBoardPage';
import { TypeAndBoard } from './TypeAndBoardPage';
import { WizardDetail } from './types';

export const wizardPageDetails: WizardDetail[] = [
  {
    header: 'Board',
    title: 'Add New Training',
    description: 'Select Training Type & Board',
    form: TypeAndBoard,
  },
  {
    header: 'Specialty',
    title: 'Select Specialty',
    description: 'Choose the specialty for American Board of Internal Medicine',
    form: SpecialtyBoardForm,
  },
  {
    header: 'Facility',
    title: 'Select Facility',
    description: 'Choose the Training facility',
    form: FacilityFormPage,
  },
  {
    header: 'Dates',
    title: 'Training Dates & Completion',
    description: 'Specify training period and completion status',
    form: DatesForm,
  },
];
